import Button from '@atlaskit/button'
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog'
import * as React from 'react'
import { SendUIEvent } from '../services/AnalyticsClient'

export function DownloadInProgressModal({ downloadUrl }) {
  React.useEffect(() => {
    if (downloadUrl) {
      window.open(downloadUrl, '_self')
    }
  }, [downloadUrl])

  return (
    <Modal width='small'>
      <ModalHeader>
        <ModalTitle>Creating file...</ModalTitle>
      </ModalHeader>
      <ModalBody>
        {downloadUrl && (
          <p style={{ padding: '10px 0' }}>
            Click on <a href={downloadUrl}>link</a> if file download has not started
          </p>
        )}
      </ModalBody>
    </Modal>
  )
}
